/* React hooks */
import { useContext } from "react";
/* Contexts */
import PagerContext from "../context/PagerProvider";

export default function usePager() {
    return useContext(PagerContext)
};